export default __webpack_public_path__ + "static/03-01-analyse-review-work-b0174fa5825c030551abc49725187b5c.mp4";